import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// CSS imports
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    themes: {
      light: {
        primary: '#1e75b9',
        accent: '#4fa2db',
        secondary: '#ee4036'
      },
    },
  },
});
